import { DialogId, DialogSchema } from '@feedyou/schema'
import { STABLE_EMPTY_SET } from '@feedyou/utils'
import { memoizeByRefAndId } from '../performance/memoizeByRefAndId'

type DialogChildMap = Map<DialogId, Set<DialogId>>

/**
 * Perfo
 * @param getChildren
 */
export function makeStableDialogChildMapCreator(
  childGetter: (dialog: DialogSchema) => Set<DialogId>
) {
  const getChildren = memoizeByRefAndId(childGetter)
  let previousResult: DialogChildMap = new Map()

  return (dialogsArray: DialogSchema[]): DialogChildMap => {
    const nextResult: DialogChildMap = new Map()

    dialogsArray.forEach(dialog => {
      nextResult.set(dialog.id, getChildren(dialog))
    })

    const mapUnchanged =
      previousResult.size === nextResult.size &&
      dialogsArray.length === previousResult.size &&
      dialogsArray.every(
        d =>
          previousResult.has(d.id) && areSetsEqual(previousResult.get(d.id), nextResult.get(d.id))
      )

    if (mapUnchanged) {
      return previousResult
    }

    previousResult = nextResult
    return nextResult
  }
}

function areSetsEqual<T>(
  left: Set<T> = STABLE_EMPTY_SET,
  right: Set<T> = STABLE_EMPTY_SET
): boolean {
  if (left.size !== right.size) {
    return false
  }

  for (const value of left) {
    if (!right.has(value)) {
      return false
    }
  }

  return true
}
